var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHidePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1402 16.4719C11.5993 16.5742 11.05 16.6254 10.4995 16.625C6.58129 16.625 3.26504 14.0499 2.14941 10.5C2.44977 9.54459 2.91241 8.64803 3.51704 7.84962M8.64279 8.64412C9.13511 8.1518 9.80285 7.87522 10.4991 7.87522C11.1954 7.87522 11.8631 8.1518 12.3554 8.64412C12.8477 9.13645 13.1243 9.80418 13.1243 10.5004C13.1243 11.1967 12.8477 11.8644 12.3554 12.3567M8.64279 8.64412L12.3554 12.3567M8.64279 8.64412L12.3545 12.355M12.3554 12.3567L15.235 15.2355M8.64454 8.645L5.76579 5.76625M5.76579 5.76625L2.62454 2.625M5.76579 5.76625C7.1766 4.85587 8.8205 4.37273 10.4995 4.375C14.4178 4.375 17.734 6.95012 18.8497 10.5C18.2337 12.4516 16.9547 14.1265 15.2342 15.2346M5.76579 5.76625L15.2342 15.2346M15.2342 15.2346L18.3745 18.375",
    stroke: "#4E4F51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePassword);
export default __webpack_public_path__ + "static/media/hide_password.3ef5f595239acab46bb3c18b33cc282d.svg";
export { ForwardRef as ReactComponent };